module.exports = __webpack_public_path__ + "img/icon-step@3x3.a2cbecf2.png";